import styled from 'styled-components';

export const EnrollmentContainer = styled.div`
    display: flex;
    padding: 80px 0 50px; /* Added top padding for fixed header */
    overflow: hidden;
    min-height: 500px;

    @media (max-width: 1200px) {
        flex-direction: column;
        padding: 80px 0 50px; /* Ensure padding on mobile too */
    }
`

export const EnrollmentMain = styled.div`
    flex: 1;
`

export const EnrollmentAside = styled.div`
    width: 360px;
    margin-left: 60px;
    
    @media (max-width: 1200px) {
        width: 100%;
        margin-left: 0;
        margin-bottom: 44px;
        margin-top: 44px;
    }
`

interface AsideBoxProps {
    whiteBg?: boolean;
}

export const AsideBox = styled.div<AsideBoxProps>`
    background-color: ${({ whiteBg }) => whiteBg ? '#fff' : '#ffdee14d'};
    border-radius: 12px;
    border: ${({ whiteBg }) => whiteBg ? '1px solid #ddd' : '0 none'};
    overflow: hidden;
    padding: 24px 20px;
    background-color: #fff;
    color: #000000;
    box-shadow:5px 5px #2372B9;
    padding: 20px 24px;
    border: 1px solid #D9D9D9;
    margin-right: 5px;
    margin-bottom:15px;

    &:last-child{
        box-shadow:none;
        justify-content: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        h4{
            font-weight: 600;
             font-size: 30px;
            line-height: 30px;
             color: #2372B9;
        }
        button{
            height: 40px;
            margin-top: 10px;
        }
    }


`


export const AsideBoxHeader = styled.div`
    margin-bottom: 32px;
    display:flex;
    align-items:center;
    flex-direction: column;
    div{
        display:flex;  
        align-items:center;
    }
    h5{
        margin: 0;
        font-weight: 500;
        font-size: 32px;
    }
    h4{
        margin: 0;
        font-weight: 500;
        font-size: 64px;
    }
`

export const AsideBoxBody = styled.div`
.svg-inline--fa {
    width:0.75em !important;
}

`

export const EnrollmentStepWrapper = styled.div`
    padding: 20px 0;

    .checkbox-item {
        flex: inherit;
    }

    h6{
        font-weight: 600;
font-size: 20px;
line-height: 28px;
color: #2372B9;
    }
`

export const EnrollmentStepFooter = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    margin-top: 44px;
`

export const EnrollmentRadioGroup = styled.div`
    display: flex;
    margin: 20px -20px;

    @media (max-width: 768px) {
        flex-direction: column;
    }
`

export const EnrollmentRadioBox = styled.div`
    flex: 1;
    border: 1px solid #ddd;
    border-radius: 14px;
    padding: 24px 20px;
    cursor: pointer;
    margin: 0 20px;
    position: relative;
    transition: all .3s;
    top: 0;

    :hover {
        border-color: #000000de;
    }

    & > div{
        display: flex;
        align-items: center;
    }

    p{
        margin: 8px 0 0;
        font-size: 14px;
        color: #666;
    }

    @media (max-width: 768px) {
        margin-top: 8px;
        margin-bottom: 8px;
    }
`

export const EnrollmentFormRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin: 16px -20px;

    @media (max-width: 768px) {
        flex-direction: column;
        margin-top: 4px;
        margin-bottom: 4px;
    }
`

interface EnrollmentFormColProps {
    full?: boolean;
}

export const EnrollmentFormCol = styled.div<EnrollmentFormColProps>`
    flex: ${({ full }) => full ? '0 0 100%' : '0 0 50%'};
    padding: 0 20px;

    .react-datepicker-wrapper input[type="text"] {
        width: 100%;
        height: 38px;
        padding: 0 11px;
        border: 1px solid #ced4da;
        border-radius: 4px;
    }

    .dropdown button{
        width: 100%;
        border: 1px solid #ced4da;
    }

    .checkbox-item{
        padding-left: 0;
        padding-right: 0;
    }
    .svg-inline--fa{
        max-width:15px !important;
        min-width:10px !important;
    }


    .error{
        ${EnrollmentRadioBox} {
            border-color: #2372B9;
        }
    }

    @media (max-width: 768px) {
        flex: 0 0 100%;
        padding: 0 20px 12px 20px;
    }
`

export const EnrollmentAddressWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 32px;
    background-color: #fafafa;
    padding: 24px 32px;
    border-radius: 12px;
    border: 1px solid #ddd;

    b {
        font-weight: 500;
        margin-right: 6px;
    }

    p{
        margin: 8px 0;
    }

    a{
        display: inline-block;
        text-decoration: none;
        margin-left: 8px;
    }
`

export const CreditCheckSection = styled.div`
    background-color: #fafafa;
    padding: 24px 32px;
    border-radius: 12px;
    border: 1px solid #ddd;
    margin: 24px 0;

    h5 {
        margin-bottom: 24px;
    }

    p {
        color: #666;
    }

    p b {
        font-weight: 500;
    }
`

export const ReviewWrapper = styled.div`
    h5 {
        margin: 20px 0 -8px;
        padding: 0 20px;
    }
`

export const ReviewBlock = styled.div`
    padding: 8px 20px;

    h6 {
        margin-bottom: 16px;
        padding-bottom: 8px;
        font-size: 17px;
        border-bottom: 1px solid #eee;
    }
`

export const ReviewRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 12px 0;
`

export const ReviewDisclaimer = styled.div`
    margin-top: 32px;
    font-size: 14px;
    color: #666;
    font-weight: 300;
    padding: 0 20px;
`

export const PlanSummaryPromote = styled.div`
    padding-top: 2px;
    font-size: 12px;
    color: #999;
`

interface PlanSummaryRowProps {
    narrow?: boolean;
}

export const PlanSummaryRow = styled.div<PlanSummaryRowProps>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: ${({ narrow }) => { return narrow ? '4px 0' : '12px 0' }};
    font-size: 14px;
    line-height: 1.2;

    label {
        font-weight: 500;
    }

    span {
        font-size: 15px;
    }

    b {
        font-size: 20px;
        font-weight: 600;
    }
    a{
        color:#666 !important;
    }
`
export const ComparePlanSummaryRow = styled.div<PlanSummaryRowProps>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: ${({ narrow }) => { return narrow ? '4px 0' : '6px 0' }};
    font-size: 14px;
    line-height: 1.2;

    label {
        font-weight: 500;
    }

    span {
        font-size: 15px;
    }

    b {
        font-size: 20px;
        font-weight: 600;
    }
    a{
        color:#666 !important;
    }
`
export const BenefitsLink = styled.button`
    cursor: pointer;
    margin-top: 24px;
    border: 0 none;
    background-color: transparent;
    color: ${({ theme }) => theme};
    font-weight: 700;
`

export const BenefitsRow = styled.div`
    display: flex;

    @media (max-width: 768px) {
        flex-direction: column;
    }
`

export const BenefitsCol = styled.div`
    flex: 1;
    padding: 0 20px;

    h5 {
        font-size: 13px;
        color: #ff5b6a;
        font-weight: 700;
        margin-bottom: 10px;
    }

    p {
        font-size: 12px;
        margin-bottom: 20px;
    }

    @media (max-width: 768px) {
        padding: 0;
    }
`

export const BenefitsIcon = styled.div`
    width: 85px;
    height: 85px;
    display: flex;
    align-items: center;
    border-radius: 50%;
    margin-bottom: 15px;
    justify-content: center;
    background-color: #fff;

    img {
        width: 50px;
        height: 50px;
    }
`

export const PlanSummaryBenefits = styled.div`
    margin-top: 24px;

    h6 {
        font-weight: bold;
        font-size: 15px;
    }

    ${BenefitsRow} {
        flex-direction: column;
    }

    ${BenefitsCol} {
        display: flex;
        align-items: center;
        padding: 0 2px;
        margin: 4px 0;

        h5 {
            color: inherit;
            font-size: 13px;
            margin-bottom: 0;
        }
    }

    ${BenefitsIcon} {
        width: 32px;
        height: 32px;
        margin-right: 12px;
        margin-bottom: 0;
        background-color: transparent;

        img {
            width: 24px;
            height: 24px;
        }
    }
`

export const InputWithMask = styled.div`
    position: relative;

    .mask-input {
        position: absolute;
        bottom: 0;
        left: 0;
    }
`

interface InputMaskToggleProps {
    active: boolean;
}

export const InputMaskToggle = styled.button<InputMaskToggleProps>`
    display: inline-block;
    width: 24px;
    height: 24px;
    mask: ${({ active }) => active ? 'url("/images/EyeOff.svg") 0 0 no-repeat' : 'url("/images/Eye.svg") 0 0 no-repeat'};
    mask-size: cover;
    background-color: #2372B9;
    border: 0 none;
    cursor: pointer;
    position: absolute;
    bottom: 16px;
    right: 16px;
    z-index: 2;
    padding: 0;
`

export const ErrorModalBody = styled.div`
    text-align: center;
    padding: 44px 0;

    h2 {
        font-size: 26px;
        font-weight: 700;
    }

    p {
        font-size: 16px;
        margin-bottom: 44px;
        
        a {
            color: '#2372B9';
            text-decoration: none;
            font-weight: 600;
        }
    }
`

export const PaymentusText = styled.div`
    text-align: center;

    p {
        max-width: 600px;
        margin-left:auto;
        margin-right: auto;
    }
`

export const DepositeSection = styled.div`
    .Loading-Iframe {
        display: none;
    }
`

export const PaymentusOpenContent = styled.div`
    display: flex;
    margin-bottom: 20px;
    padding: 20px 0;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
    }
`

export const PaymentusLabel= styled.div`
    color: #7E8083;
    flex: 0 0 50%;

    @media (max-width: 768px) {
        margin-bottom: 20px;
    }
`

export const PaymentusService = styled.div`
    text-align: center;
    padding-left: 50px;

    @media (max-width: 768px) {
        padding-left: 0px;
    }

    h4 {
        font-size: 24px;
    }
    a {
        font-size: 30px;
    }
`